import React from "react";
import { Modal, Icon } from "antd";
import { useSelector } from "react-redux";

/**
 * Alerta "NF já registrada". Exibido quando o backend indica que a NF informada
 * já possui movimento(s). Permite cancelar ou continuar mesmo assim.
 */
const StockMovementDuplicateNfModal = ({
  visible,
  message,
  missingItems = [],
  onCancel,
  onContinue,
}) => {
  const { translation } = useSelector((state) => state.app);
  const t = translation?.stockItem?.movements?.duplicateNf || {};

  return (
    <Modal
      visible={visible}
      title={
        <span>
          <Icon type="warning" style={{ color: "#faad14", marginRight: 8 }} />
          {t.title || "NF já registrada"}
        </span>
      }
      okText={t.continue || "Continuar mesmo assim"}
      cancelText={t.cancel || "Cancelar movimento"}
      onOk={onContinue}
      onCancel={onCancel}
    >
      <p>{message}</p>
      {missingItems.length > 0 && (
        <ul>
          {missingItems.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      )}
    </Modal>
  );
};

export default StockMovementDuplicateNfModal;
